import {
  evalPageImagePrefetchSettled,
  evalPagePrefetchImageRefs,
  startImageWarm,
} from 'features/knowledgeDocumentViewer/utils/pageMetadataEvalPrefetch'
import { useRolodexSignedURLs } from 'features/rolodex'
import { useEffect, useMemo, useState } from 'react'

function useWarmedImageUrl(url: string | undefined): string | undefined {
  const [settledUrl, setSettledUrl] = useState<string>()
  useEffect(() => {
    if (url) return startImageWarm(url, () => setSettledUrl(url))
  }, [url])
  return settledUrl
}

export function useEvalPageImagePrefetch(
  siteId: string,
  documentId: string,
  pageNum: number,
  hiRes = true
): boolean {
  const refs = useMemo(
    () => evalPagePrefetchImageRefs({ siteId, documentId, pageNum }),
    [documentId, pageNum, siteId]
  )
  const high = useRolodexSignedURLs(hiRes ? refs.hiRes : undefined)
  const thumb = useRolodexSignedURLs(refs.thumbnail)
  const highWarmedUrl = useWarmedImageUrl(high.url)
  const thumbWarmedUrl = useWarmedImageUrl(thumb.url)
  return evalPageImagePrefetchSettled(
    hiRes,
    { url: high.url, isLoading: high.isLoading, warmedUrl: highWarmedUrl },
    { url: thumb.url, isLoading: thumb.isLoading, warmedUrl: thumbWarmedUrl }
  )
}
